import { call, put, takeLatest } from "redux-saga/effects";
import { axiosRestInstance } from "../../../../common/axios";
import { benefitActivityDashboardSliceAction } from "../../../slices/partner-program/benefit-activity-dashboard";
import { mapBenefitActivityDashboardResponse } from "../../../slices/partner-program/benefit-activity-dashboard/mapper";
import {
  BenefitActivityDashboardQueryType,
  BenefitActivityDashboardResponseType,
} from "../../../slices/partner-program/benefit-activity-dashboard/Types";
import { benefitActivityDashboardSagaActionTypes } from "./saga-actions";

const OPTIONAL_QUERY_KEYS = [
  "partner_ids",
  "benefit_ids",
  "statuses",
  "hid_user_ids",
  "partner_user_ids",
  "delivered_date_from",
  "delivered_date_to",
  "planned_date_from",
  "planned_date_to",
  "search",
] as const;

const buildQueryParams = (query: BenefitActivityDashboardQueryType) => {
  const params: Record<string, string | number | boolean> = {
    has_benefits: query.has_benefits,
    page: query.page,
    limit: query.limit,
  };
  OPTIONAL_QUERY_KEYS.forEach((key) => {
    const value = query[key];
    if (value) params[key] = value;
  });
  return params;
};

const getBenefitActivityDashboardAPI = async (
  query: BenefitActivityDashboardQueryType
) => {
  const response = await axiosRestInstance.get<BenefitActivityDashboardResponseType>(
    "/partner-program/benefit-activity-log/dashboard",
    { params: buildQueryParams(query) }
  );
  return response.data;
};

function* getBenefitActivityDashboardSaga(action: {
  type: string;
  payload: BenefitActivityDashboardQueryType;
}) {
  try {
    yield put(benefitActivityDashboardSliceAction.setBenefitActivityDashboardLoading(true));
    yield put(benefitActivityDashboardSliceAction.setBenefitActivityDashboardError(null));

    const response: BenefitActivityDashboardResponseType = yield call(
      getBenefitActivityDashboardAPI,
      action.payload
    );

    if (response?.success === false) {
      yield put(benefitActivityDashboardSliceAction.clearBenefitActivityDashboardData());
      yield put(
        benefitActivityDashboardSliceAction.setBenefitActivityDashboardError(
          response?.message || "Unable to load benefit activity log."
        )
      );
      return;
    }

    yield put(
      benefitActivityDashboardSliceAction.setBenefitActivityDashboardData(
        mapBenefitActivityDashboardResponse(response, action.payload)
      )
    );
  } catch (e: any) {
    yield put(benefitActivityDashboardSliceAction.clearBenefitActivityDashboardData());
    yield put(
      benefitActivityDashboardSliceAction.setBenefitActivityDashboardError(
        e?.response?.data?.message ||
          e?.message ||
          "Unable to load benefit activity log."
      )
    );
  } finally {
    yield put(benefitActivityDashboardSliceAction.setBenefitActivityDashboardLoading(false));
  }
}

function* benefitActivityDashboardSaga() {
  yield takeLatest(
    benefitActivityDashboardSagaActionTypes.callGetBenefitActivityDashboardSaga,
    getBenefitActivityDashboardSaga
  );
}

export default benefitActivityDashboardSaga;
